<template>
  <div class="layout">
    <div class="f-header">
      <Fheader class="hidden-sm-and-down" />
      <mobileHeader class="hidden-md-and-up" />
    </div>
    <mainView />
    <div class="f-footer">
      <Ffooter />
    </div>
    <transition
      :duration="1000"
      name="custom-classes-transition"
      enter-active-class="animated slideInLeft"
      leave-active-class="animated slideOutLeft"
    >
      <keep-alive>
        <leftDraw v-if="isMobileSideBar" />
      </keep-alive>
    </transition>
    <!-- <transition :duration="1000" name="custom-classes-transition"  enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
			<keep-alive>
				<rightDraw v-if="isRightToolBar" />
			</keep-alive>
    </transition>-->
    
  </div>
</template>
<script>
import Fheader from "./components/header";
import mobileHeader from "./components/header/mobile";
import mainView from "./components/mainView";
import Ffooter from "./components/footer";
import leftDraw from "./components/leftDraw";
import rightDraw from "./components/rightDraw";
import { logout } from "@/utils/auth";

export default {
  name: "Header",
  components: {
    Fheader,
    mobileHeader,
    mainView,
    Ffooter,
    leftDraw,
    rightDraw,
    
  },
  data() {
    return {
      isEditPasswordDialog: true
    };
  },
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + +new Date()
        : this.$route + +new Date();
    },
    isMobileSideBar() {
      return this.$store.state.app.mobileSideBar;
    }
  },
  methods: {
    change(val) {
      this.$i18n.locale = val;
    }
    
  }
};
</script>
<style lang="scss" scoped>
.layout {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 120px 0 81px 0;
  position: relative;
  overflow: hidden;
  .f-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
  .f-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }
}
@media screen and (max-width: 992px) {
  .layout {
    padding: 54px 0 81px 0;
  }
}
</style>



